const dompromise = require('dompack/src/promise');

/** @require: const Promise = require('@webhare-system/compat/promise.es') */

// Workaround babel error that 'Promise.defer = ' isn't converted to the Babel promise type
let PromiseType = Promise;
if(!PromiseType.defer)
{
  PromiseType.defer = dompromise.createDeferred;
}
module.exports = PromiseType;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/system/nodejs/compat/promise.es